import FColumnCellMDP from '../FColumnCellMDP';
export default class FCellCurrencyMDP implements FColumnCellMDP {
    rounded: boolean | undefined;
    enableDecimal: boolean | undefined;
    enableIndianNotation: boolean | undefined;
    constructor({rounded=false,enableDecimal=true,enableIndianNotation=false}: {rounded?: boolean;enableDecimal?: boolean;enableIndianNotation?: boolean}) {
        this.rounded = rounded;
        this.enableDecimal = enableDecimal;
        this.enableIndianNotation = enableIndianNotation;
    }
    componentName: string = "FCellCurrency";
    getMetaData(): object {
        return {
            componentName: this.componentName,
            props: {
                rounded: this.rounded,
                enableDecimal: this.enableDecimal,
                enableIndianNotation: this.enableIndianNotation
            }
        }
    }

}